angular.module("accessoSilos.components", [])
    .component("accessoSilos", {
        templateUrl: 'ng/components/accessoSilos/accessoSilos.view.html',
        bindings: {},
        controller: AccessoSilosController,
        controllerAs: 'accessoSilosCtrl'
    })

function AccessoSilosController(
    $simulationService,
    $timeout
) {
    var self = this;

    self.$onInit = function () {

    }

    self.getAccess = function () {
        self.restReady = true;
        $simulationService.getSamlCerved()
            .then(function (response) {
                if (response.success) {
                    self.token = response.value;
                    self.url = response.url;
                    self.name = response.name;


                    $timeout(function () {
                        jQuery('#nascosto').trigger('click');
                        self.restReady = false;
                    }, 200)
                }
            })
            .catch(function (error) {
                console.log(error);
            })
    }
}